module.exports = __webpack_public_path__ + "img/paved_concreted.7a7821b5.png";